var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.232 28.641C13.422 28.868 13.703 29 14 29L20 29L20 33C20 33.552 20.447 34 21 34L24 34C24.4 34 24.762 33.762 24.919 33.395L27.659 27L28 27C28 27.552 28.447 28 29 28L33 28C33.553 28 34 27.552 34 27L34 17C34 16.448 33.553 16 33 16L29 16C28.447 16 28 16.448 28 17L28 17.522L24.371 16.071C24.254 16.024 24.127 16 24 16L16 16C15.517 16 15.103 16.346 15.016 16.821L13.016 27.821C12.963 28.113 13.043 28.413 13.232 28.641ZM30 18L32 18L32 26L30 26L30 18ZM16.834 18L23.808 18L28 19.677L28 25L27 25C26.6 25 26.238 25.238 26.081 25.606L23.341 32L22 32L22 28C22 27.448 21.553 27 21 27L15.198 27L16.834 18Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "thumbs-down.f3f549552053b9c6829cf8e3f85e0e52.svg";